<template>
    <div class="notes-list">
        <TotemSelect
            :options="sortOptions"
            :placeholder="$t('MemoPageNotesList.sort')"
            icon="filter"
            class="notes-list__sorting"
            @input="selectSorter"
            :reduce="option => option.value"
            :value="this.sorting"
        />
        <TotemSearch class="notes-list__search" v-model="search" v-on:clearSearch="onClearSearch"/>
        <span class="notes-list__title" v-if="userNotes.length === 0" v-html="$t('MemoPageNotesList.not_yet_notes')"></span>
        <span class="notes-list__title" v-if="userNotes.length > 0" v-html="$t('MemoPageNotesList.courses_with_notes')"></span>
        <TotemScrollbar class="notes-list__scrollbar" v-if="userNotes.length > 0">
            <ul class="notes-list__list">
                <li
                    class="notes-list__item"
                    :class="{'-active': currentNote && +currentNote.courseId === +note.courseId}"
                    v-for="(note, index) in filteredNotes"
                    :key="index"
                    @click="selectNote(note)"
                >
                    {{ note.courseTitle }}
                </li>
            </ul>
        </TotemScrollbar>
    </div>
</template>

<script>
    export default {
        name: 'memo-page-notes-list',
        props: {
            userNotes: Array,
            currentNote: Object
        },
        data () {
            return {
                search: '',
                sorting: 'byDateNewest'
            }
        },
        computed: {
            sortOptions () {
                return [
                    { value: 'alphabeticallyAsc', label: this.$t('CollectionFilter.alpha_order_asc') },
                    { value: 'alphabeticallyDesc', label: this.$t('CollectionFilter.alpha_order_desc') },
                    { value: 'byDateNewest', label: this.$t('CollectionFilter.from_new_to_old') },
                    { value: 'byDateOldest', label: this.$t('CollectionFilter.from_old_to_new') }
                ]
            },
            filteredNotes () {
                let sortingMethod = this.sortAlphabeticallyAsc
                if (this.sorting) {
                    switch (this.sorting) {
                    case 'alphabeticallyAsc':
                        sortingMethod = this.sortAlphabeticallyAsc
                        break
                    case 'alphabeticallyDesc':
                        sortingMethod = this.sortAlphabeticallyDesc
                        break
                    case 'byDateNewest':
                        sortingMethod = this.sortByDateNewest
                        break
                    case 'byDateOldest':
                        sortingMethod = this.sortByDateOldest
                        break
                    }
                }
                let filters = [this.filterBySearch, sortingMethod]
                return filters.reduce((acc, filter) => filter(acc), this.userNotes)
            }
        },
        methods: {
            selectSorter (sorter) {
                if (sorter === null) {
                    sorter = 'byDateNewest'
                }
                this.sorting = sorter
            },
            selectNote (note) {
                this.$emit('selectNote', note)
            },
            filterBySearch (data) {
                if (this.search === '') {
                    return this.userNotes
                }
                return data.filter(note => {
                    return note.courseTitle.toLowerCase().search(this.search.toLowerCase()) !== -1
                })
            },
            sortAlphabeticallyAsc (data) {
                return Array.from(data).sort((a, b) => {
                    return a.courseTitle.localeCompare(b.courseTitle)
                })
            },
            sortAlphabeticallyDesc (data) {
                return Array.from(data).sort((a, b) => {
                    return b.courseTitle.localeCompare(a.courseTitle)
                })
            },
            sortByDateNewest (data) {
                return Array.from(data).sort((a, b) => {
                    return b.updatedAt - a.updatedAt
                })
            },
            sortByDateOldest (data) {
                return Array.from(data).sort((a, b) => {
                    return a.updatedAt - b.updatedAt
                })
            },
            onClearSearch () {
                this.search = ''
            }
        }
    }
</script>

<style lang="scss" scoped>
.notes-list {
    display: flex;
    flex-direction: column;
    width: 400px;

    &__sorting {
        margin: 0 0 20px;
        flex-grow: unset;
    }

    &__search {
        align-self: flex-start;
        margin: 0 0 30px !important;
    }

    &__title {
        font-size: 2rem;
        display: inline-block;
        margin: 0 0 20px;
    }

    &__scrollbar {
        border: 1px solid $quill_gray;
        background: $white;
        flex: 1;
    }

    &__list {
        height: 288px;

        [class*="desktop_x"] & {
            height: auto;
            width: 400px;
        }
    }

    &__item {
        font-size: 1.4rem;
        height: 48px;
        padding: 8px 15px;
        list-style: none;

        &:hover {
            cursor: pointer;
            background-color: $champagne;
        }

        &.-active {
            background-color: $champagne;
        }
    }
}
</style>
